// extracted by mini-css-extract-plugin
export default {"root":"CurrentFile_root__MBYhw","strong":"CurrentFile_strong__-EqHd","placeHolderShimmer":"CurrentFile_placeHolderShimmer__A6hmM"};